import * as R from "ramda";
import { Affix, Tree } from "antd";
import React, { useEffect, useState } from "react";

import {
  TreeOfMediaSources,
  EquipmentUploadPage,
} from "./equipment-upload-page";
import { VideoResourceTab } from "./video-resource-tab";

import "./video-resource-page.scss";

const { TreeNode } = Tree;

export const treeNodeIsUnSelect = (args) => {
  return R.pipe(
    R.pathOr([], [1, "selectedNodes"]),
    R.length,
    R.equals(0)
  )(args);
};

// noinspection JSNonASCIINames,NonAsciiCharacters
/**
 * 1. 直播切片
 * 2. 本地手动上传
 * 3. 本地自动上传
 * 4. 合成素材
 * 5. 图传视频素材(APP)
 * @type {{}}
 */
export const uploadResourceChannelMap = {
  直播切片: 1,
  本地手动上传: 2,
  本地自动上传: 3,
  合成素材: 4,
  "图传视频素材(APP)": 5,
  智能剪辑视频: 6,
  片头片尾: 11,
  访客视频: 12,
};

export const UploadResourceChannelToTextMap = R.invertObj(
  uploadResourceChannelMap
);

export const TreeNodeValueToTextMap = {
  //  type="", atrribute=""
  "0-0": "全部类型",
  //   type="video", attribute=""
  "0-1": "本地视频(手动+自动上传)",
  //  type="video", attribute="live"
  "0-2": "直播切片(直播视频切出来的片段)",
  "0-12": "访客视频",
  "0-9": "AI视频",
  "0-10": "片头片尾",
  //  type="video", attribute="compose"
  // "0-3": "视频合成素材",
  //  type="image"
  "0-4": "图片",
  //  type="audio"
  "0-5": "音频",
  //  type="text"
  "0-6": "字幕",
  // "0-7": "视频模板",
  "0-8": UploadResourceChannelToTextMap["5"],
};

export const ChannelOptions = R.pipe(
  R.toPairs,
  R.map(([label, value]) => ({ value, label }))
)(uploadResourceChannelMap);

export const channelToText = (channel) => {
  return UploadResourceChannelToTextMap[channel] || "未知";
};

// noinspection JSNonASCIINames
export const TreeNodeValueToParamsMap = {
  "0-0": {},
  "0-1": {
    type: "video",
    channel: [
      uploadResourceChannelMap.本地手动上传,
      uploadResourceChannelMap.本地自动上传,
    ],
  },
  "0-2": { type: "video", channel: [uploadResourceChannelMap.直播切片] },
  "0-9": { type: "video", channel: [uploadResourceChannelMap.智能剪辑视频] },
  "0-10": { type: "video,image", channel: [uploadResourceChannelMap.片头片尾] },
  "0-3": { type: "video", channel: [uploadResourceChannelMap.合成素材] },
  "0-4": { type: "image" },
  "0-5": { type: "audio" },
  "0-6": { type: "text" },
  "0-8": {
    type: "video",
    channel: [uploadResourceChannelMap["图传视频素材(APP)"]],
  },
  "0-12": {
    type: "video",
    channel: [uploadResourceChannelMap.访客视频],
  },
};

export const TreeNodeTextToValueMap = R.invertObj(TreeNodeValueToTextMap);

/**
 * 全部类型
 * 本地视频
 * 直播切片
 * 合成素材
 * 图片
 * 音频
 * 字幕
 * 视频模板
 * @param props
 * @returns {Element}
 * @constructor
 */
export const VideoResourcePage = (props) => {
  const orderId = R.pathOr("0", ["match", "params", "orderid"], props) * 1;
  const { height } = props;

  const [selectedKeys, setSelectedKeys] = useState([
    TreeNodeTextToValueMap["全部类型"],
  ]);

  useEffect(() => {
    const setSelectedType = R.pathOr(R.T, ["setSelectedType"], props);
    //  设置选中的tab, 第一个
    setSelectedType(selectedKeys[0]);
  }, [props.setSelectedType, selectedKeys]);

  //  这是专门记录图传视频素材的选中状态, 只有选中了图传视频素材, treeDataSelectedKeys 才会有值
  const [treeDataSelectedKeys, setTreeDataSelectedKeys] = useState([]);

  return (
    <div className="flex">
      <div style={{ display: "flex", height }}>
        <Affix
          offsetTop={0}
          className="antd-affix"
          target={() => document.querySelector("#mainWrapper")}
        >
          <div
            style={{
              width: 260,
              paddingRight: 12,
              height,
              borderRight: "1px solid #e8e8e8",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Tree
              showIcon
              blockNode
              selectedKeys={selectedKeys}
              defaultExpandAll
              className="resource-left-tree"
              onSelect={(...args) => {
                const keys = args[0] || [];
                if (keys.includes("0-8")) {
                  return;
                }
                if (!treeNodeIsUnSelect(args)) {
                  setSelectedKeys(keys);
                  setTreeDataSelectedKeys([]);
                }
              }}
            >
              {Object.entries(TreeNodeValueToTextMap).map(([key, value]) => (
                <TreeNode title={value} key={key} />
              ))}
            </Tree>
            <TreeOfMediaSources
              {...props}
              selectedKeys={treeDataSelectedKeys}
              onSelect={(...args) => {
                if (!treeNodeIsUnSelect(args)) {
                  setTreeDataSelectedKeys(args[0]);
                  setSelectedKeys([]);
                }
              }}
            />
          </div>
        </Affix>
      </div>
      <div className="main-page w-full p-2">
        {treeDataSelectedKeys.length ? (
          //  图传视频
          <EquipmentUploadPage
            {...props}
            selectedKeys={treeDataSelectedKeys}
            extraParams={TreeNodeValueToParamsMap["0-8"]}
          />
        ) : (
          //  全部类型, 本地视频, 直播切片, 合成素材, 图片, 音频, 字幕 等
          <VideoResourceTab
            extraParams={TreeNodeValueToParamsMap[selectedKeys[0]]}
            key={JSON.stringify(selectedKeys)}
            selectedKeys={selectedKeys}
            orderId={orderId}
            {...props}
          />
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/tab-pages/video-resource-page.js